import * as React from 'react';
import { createPortal } from 'react-dom';
import { classNames } from '@wix/answers-lib';
const ExpandedImage = ({ value, isExpanded, setExpandImgRef, hideFromDOM, onDismiss, }) => {
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => setMounted(true), []);
    return mounted && !value.link
        ? createPortal(React.createElement("div", { className: classNames('image-fullscreen-container', {
                expanded: isExpanded,
            }) },
            React.createElement("div", { tabIndex: -1, id: value.src, ref: setExpandImgRef, className: classNames('overlay', 'expanded-img', {
                    hide: hideFromDOM,
                }), onClick: onDismiss },
                React.createElement("img", { loading: 'lazy', src: value.src, alt: value.alt || '' }))), document.body)
        : null;
};
export default ExpandedImage;
